import client from './client';

export const login = (data) => client.post('/api/auth/login', data);
export const register = (data) => client.post('/api/auth/register', data);
export const getMe = () => client.get('/api/auth/me');
export const updateProfile = (data) => client.patch('/api/auth/profile', data);
